import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import cartService from "../services/cartService";
import { message } from "utils/Funciones";

const initialState = {
    isMutation: { success: false, loading: false },
    userCart: { cart: {} },
    userCartB: { cart: {} },
    numOfCartItems: 0,
    numOfCartItemsB: 0
};

export const addToCart = createAsyncThunk(
    "cart/addToCart",
    async (data, thunkAPI) => {
        try {
            const res = await cartService.addToCart(data.formData, data.token);
            message(res.message, 'success', 5)
            return res
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const addToCartB = createAsyncThunk(
    "cart/addToCartB/addToCartB",
    async (data, thunkAPI) => {
        try {
            const res = await cartService.addToCartB(data.formData);
            message(res.message, 'success', 5)
            return res
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);


export const addToCartWhitBarCode = createAsyncThunk(
    "cart/addToCartWhitBarCode",
    async (data, thunkAPI) => {
        try {
            const res = await cartService.addToCartWhitBarCode(data.formData, data.token);
            message(res.message, 'success', 5)
            return res
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getMyCart = createAsyncThunk(
    "cart/getMyCart",
    async (data, thunkAPI) => {
        try {
            return await cartService.getMyCart(data.query, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getMyCartB = createAsyncThunk(
    "cart/getMyCartB/getMyCartB",
    async (data, thunkAPI) => {
        try {
            return await cartService.getMyCartB(data.query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const updateCartItemQty = createAsyncThunk(
    "cart/updateCartItemQty",
    async (data, thunkAPI) => {
        try {
            return await cartService.updateCartItemQty(data.formData, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const removeFromCart = createAsyncThunk(
    "cart/removeFromCart",
    async (data, thunkAPI) => {
        try {
            return await cartService.removeFromCart(data.itemId, data.userId, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const removeFromCartB = createAsyncThunk(
    "cart/removeFromCartB",
    async (data, thunkAPI) => {
        try {
            return await cartService.removeFromCartB(data.itemId, data.userId);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const clearCart = createAsyncThunk(
    "cart/clearCart",
    async (data, thunkAPI) => {
        try {
            return await cartService.clearCart(data.userId, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const applyDiscount = createAsyncThunk(
    "cart/applyDiscount",
    async (data, thunkAPI) => {
        try {
            return await cartService.applyDiscount(data.formData, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        resetMutationResult: (state) => {
            state.isMutation.success = false;
        },
        resetUserCart: (state, action) => {
            state.userCart.cart = action.payload
        },
        resetUserCartB: (state, action) => {
            state.userCartB.cart = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            //____________________ADD_TO_CART____________________//
            .addCase(addToCart.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(addToCart.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
            })
            .addCase(addToCart.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
            //____________________ADD_TO_CART B____________________//
            .addCase(addToCartB.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(addToCartB.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
            })
            .addCase(addToCartB.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
            //____________________ADD_TO_CART_WHIT_BAR_CODE____________________//
            .addCase(addToCartWhitBarCode.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(addToCartWhitBarCode.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
            })
            .addCase(addToCartWhitBarCode.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
            //_____________________GET_MY_CART____________________//
            .addCase(getMyCart.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(getMyCart.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.error = false;
                state.userCart.cart = action.payload.data;
                state.numOfCartItems = action.payload.numOfCartItems;
            })
            .addCase(getMyCart.rejected, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.error = action.payload;
            })
            //_____________________GET_MY_CART_B____________________//
            .addCase(getMyCartB.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(getMyCartB.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.error = false;
                state.userCartB.cart = action.payload.data;
                state.numOfCartItemsB = action.payload.numOfCartItems;
            })
            .addCase(getMyCartB.rejected, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.error = action.payload;
            })
            //____________________UPDATE_CART_ITEM_QTY____________________//
            .addCase(updateCartItemQty.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(updateCartItemQty.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
            })
            .addCase(updateCartItemQty.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
            //____________________REMOVE_FROM_CART____________________//
            .addCase(removeFromCart.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(removeFromCart.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
            })
            .addCase(removeFromCart.rejected, (state, action) => {
                state.isMutation.loading = false;
            })

            //____________________REMOVE_FROM_CART_B____________________//
            .addCase(removeFromCartB.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(removeFromCartB.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
            })
            .addCase(removeFromCartB.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
            //____________________CLEAR_CART____________________//
            .addCase(clearCart.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(clearCart.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true
            })
            .addCase(clearCart.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
            //____________________APPLY_DISCOUNT____________________//
            .addCase(applyDiscount.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(applyDiscount.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
            })
            .addCase(applyDiscount.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
    },
});

export const { resetMutationResult, resetUserCart, resetUserCartB } = cartSlice.actions;

export default cartSlice.reducer;

